import { useOrganization, useUser } from '@clerk/clerk-react'

import { useIsCareforceOrgAdmin } from '../hooks/useIsCareforceOrgAdmin'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import type { ReactNode } from 'react'

interface ProtectedCareforceOrgRouteProps {
  children: ReactNode
}

/**
 * Pages that edit product-wide settings.
 *
 * Narrower than Careforce membership: it requires the ACTIVE org to be
 * Careforce. A page whose edits apply to every
 * organization must not be reachable while browsing one customer, where it
 * would read as "change this org".
 */
export function ProtectedCareforceOrgRoute({
  children,
}: ProtectedCareforceOrgRouteProps) {
  const { isLoaded: userLoaded } = useUser()
  const { isLoaded: orgLoaded } = useOrganization()
  const isCareforceOrgAdmin = useIsCareforceOrgAdmin()

  return (
    <ProtectedRoute
      allowed={userLoaded && orgLoaded ? isCareforceOrgAdmin : undefined}
      message="Switch to the Careforce organization to view this page."
      toastId="careforce-org-access-denied">
      {children}
    </ProtectedRoute>
  )
}
